import { OdataFilters, queryCollection, queryParams } from "helpers/reqparams";
import moment from "moment";
import { alertRequest, body, request } from "services/request";

const resource = "api/tripSheets";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: ["id desc"] });
    return request(`${resource}/getList${query}`, { method: "GET" }, { countInHeaders: true });
};

const getItem = ({ id }: { id: number | string }) => request(`${resource}/get/${id}`, { method: "GET" });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const setStatus = (params: {}) => alertRequest(`${resource}/setStatus`, body(params));

const createCorrection = (params: { id: number; reason: string }) =>
    alertRequest(`${resource}/createCorrection`, body(params));

const getCouplingSyncPreview = (id: number | string) =>
    request(`${resource}/getCouplingSyncPreview/${id}`, { method: "GET" });

const syncCouplings = (params: { id: number; tripCouplingIds: number[]; reason?: string | null }) =>
    alertRequest(`${resource}/syncCouplings`, body(params));

const syncAssignments = (params: {
    id: number;
    assignmentIds: number[];
    updatePlan: boolean;
    updateFacts: boolean;
    reason?: string | null;
}) => alertRequest(`${resource}/syncAssignments`, body(params));

const getBidConflicts = ({ id, bidIds }: { id: number | string; bidIds: number[] }) => {
    const query = new URLSearchParams();
    bidIds.forEach((bidId) => {
        query.append("bidIds", String(bidId));
    });
    return request(`${resource}/getBidConflicts/${id}?${query.toString()}`, { method: "GET" });
};

const getChanges = (id: number | string) => request(`${resource}/getChanges/${id}`, { method: "GET" });

const toUtc = (date: string) => moment(date).utc().format();

const getFormValues = ({ carId, from, to }: { carId: number; from: string; to: string }) => {
    const query = queryParams({ carId, from: toUtc(from), to: toUtc(to) });
    return request(`${resource}/getFormValues${query}`, { method: "GET" });
};

const getCouplingSuggestions = ({ carId, from, to }: { carId: number; from: string; to: string }) => {
    const query = queryParams({ carId, from: toUtc(from), to: toUtc(to) });
    return request(`${resource}/getCouplingSuggestions${query}`, { method: "GET" });
};

const validate = ({ id, targetStatus }: { id: number | string; targetStatus: string }) => {
    const query = queryParams({ targetStatus });
    return request(`${resource}/validate/${id}${query}`, { method: "GET" });
};

const getBidsForAssignment = ({
    carId,
    driverId,
    from,
    to,
}: {
    carId: number | string;
    driverId?: number | string | null;
    from: string;
    to: string;
}) => {
    const params: { carId: number | string; driverId?: number | string; from: string; to: string } = {
        carId,
        from: from ? toUtc(from) : from,
        to: to ? toUtc(to) : to,
    };
    if (driverId) {
        params.driverId = driverId;
    }
    const query = queryParams(params);
    return request(`api/truckingBids/getListForTripSheet${query}`, { method: "GET" });
};

const generatePrintForm = (params: { id: number }) => alertRequest(`${resource}/generatePrintForm`, body(params));

export {
    index,
    getItem,
    apply,
    setStatus,
    createCorrection,
    getCouplingSyncPreview,
    syncCouplings,
    syncAssignments,
    getBidConflicts,
    getChanges,
    getFormValues,
    getCouplingSuggestions,
    validate,
    getBidsForAssignment,
    generatePrintForm,
};
